import React, { useState, useEffect, useCallback } from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import MainContent from './components/MainContent/MainContent';
import Footer from './components/MainContent/Footer';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import TermsConditions from './components/TermsConditions/TermsConditions';
import QRDownload from './components/QRDownload/QRDownload';
import WaitlistModal from './components/MainContent/JoinWaitlist/WaitlistModal';
import ToastWrapper from './components/ToastWrapper/ToastWrapper';
import './App.css';

const App: React.FC = () => {
  const [isMobile, setIsMobile] = useState(
    window.matchMedia('(max-width: 767px)').matches,
  );
  const [isTablet, setIsTablet] = useState(
    window.matchMedia('(max-width: 1199px)').matches,
  );
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [waitlistOpen, setWaitlistOpen] = useState(false);

  const openWaitlist = useCallback(() => setWaitlistOpen(true), []);
  const closeWaitlist = useCallback(() => setWaitlistOpen(false), []);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 767px)');
    const mediaQueryTablet = window.matchMedia('(max-width: 1199px)');

    const handleResize = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches);
    };

    const handleResizeTablet = (e: MediaQueryListEvent) => {
      setIsTablet(e.matches);
    };

    mediaQuery.addEventListener('change', handleResize);
    mediaQueryTablet.addEventListener('change', handleResizeTablet);
    return () => {
      mediaQuery.removeEventListener('change', handleResize);
      mediaQueryTablet.removeEventListener('change', handleResizeTablet);
    };
  }, []);

  return (
    <div className="App">
      <div id="page-bg" aria-hidden="true" />
      <div id="page-bg-gradient" aria-hidden="true" />
      <ToastWrapper
        showToast={showToast}
        message={toastMessage}
        setShowToast={setShowToast}
      />
      <Navbar
        isMobile={isMobile}
        isTablet={isTablet}
        openWaitlist={openWaitlist}
      />
      <div className="content-wrapper">
        <Routes>
          <Route path="/download" element={<QRDownload />} />
          <Route
            path="/*"
            element={
              <MainContent
                isMobile={isMobile}
                isTablet={isTablet}
                setToastMessage={setToastMessage}
                setShowToast={setShowToast}
                openWaitlist={openWaitlist}
              />
            }
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Routes>
      </div>
      <Footer />
      <WaitlistModal
        show={waitlistOpen}
        onHide={closeWaitlist}
        setShowToast={setShowToast}
        setToastMessage={setToastMessage}
      />
    </div>
  );
};

export default App;
